import http from '@/api/common'

export default {
  serviceElements() {
    return http.get('ragrating/GetServiceElementList')
  },
  upsertServiceElement(data) {
    return http.post('ragrating/UpsertServiceElement', data)
  },
  getServiceElementGroups() {
    return http.get('ragrating/GetServiceElementGroups')
  },
  getDistinctVehicleMakes() {
    return http.get('ragrating/GetVehicleMakes')
  },
  getDistinctVehicleModels({make, year}) {
    return http.get(`ragrating/GetVehicleModels?make=${make}&year=${year}`)
  },
  getServiceElementsRagRating({make, model, year, orderBy, sortBy}) {
    // First encode the make/model
    const encodedMake = encodeURIComponent(make || '')
    const encodedModel = encodeURIComponent(model || '')
    return http.get(`ragrating/GetServiceElementsRagRating?make=${encodedMake}&model=${encodedModel}&year=${year}&orderBy=${orderBy}&sortBy=${sortBy}`)
  },
  getVehicleRagRatingId({make, model, year}) {
    // First encode the make/model
    const encodedMake = encodeURIComponent(make || '')
    const encodedModel = encodeURIComponent(model || '')
    return http.get(`ragrating/GetRAGRatingVehicleId?make=${encodedMake}&model=${encodedModel}&year=${year}`)
  },
  updateRagRating(data) {
    return http.post('ragrating/UpdateRagRatingForServiceElement', data)
  },
  bulkCopyRagRating({bulkCopyParams}) {
    return http.post('ragrating/BulkCopyRagRatings', bulkCopyParams)
  },
  copyRagRating({sourceVehicleId, targetVehicleId}) {
    return http.post(`ragrating/CopyRagRatings?sourceVehicleId=${sourceVehicleId}&targetVehicleId=${targetVehicleId}`)
  },
  audit({auditDetails}) {
    return http.post('ragrating/Audit', auditDetails)
  },
  getRagAuditTypeList() {
    return http.get('ragrating/GetAuditTypeList')
  },
  getAuditLog(searchOptions) {
    return http.post('ragrating/GetAuditLog', searchOptions)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/serviceElements.js